(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rg3-booking-form"] && !Shopify.designMode) return;
  try {
    
function initRG3Bookings() {
  document.querySelectorAll('[data-rg3-booking="boka-service"]').forEach(root => {
    if (root.dataset.rg3Initialized) return;
    root.dataset.rg3Initialized = 'true';
    const vehicle = root.querySelector('select[name="contact[Typ av fordon]"]');
    const workshops = Array.from(root.querySelectorAll('[name="contact[Vart vill du ha service]"]'));
    if (!vehicle || !workshops.length) return;
    const sync = () => {
      const snow = vehicle.value === 'Snöskoter';
      for (const workshop of workshops) {
        if (workshop.tagName === 'SELECT') {
          for (const option of workshop.options) if (option.value === 'Arlanda') option.disabled = snow;
          if (snow) workshop.value = 'Orsa';
        } else {
          if (workshop.value === 'Arlanda') { workshop.disabled = snow; if (snow) workshop.checked = false; }
          if (snow && workshop.value === 'Orsa') workshop.checked = true;
        }
      }
    };
    vehicle.addEventListener('change', sync);
    sync();
  });
}
initRG3Bookings();
document.addEventListener('shopify:section:load', initRG3Bookings);

  } catch(e) { console.error(e); }
})();
})();
